module.exports = __webpack_public_path__ + "static/ocorie-abt-3-23eee7049658409c9d2aec941647f502.png";